// @ts-nocheck
import React, { createRef } from "react";
import SupportingFileProcess from "..";
import NormalSpin from "../../../../base/basicComponents/spin";
import {
  handleSortFileByStatus,
  processDefaultTableSortFile,
  flowCategoryId,
  actions,
} from "../../../publicDictionaryValues";
import ApproveNewSupportingFileComplete from "./approveNewSupportingFileComplete";
import ApproveNewSupportingFilePending from "./approveNewSupportingFilePending";
import ReviseNewSupportingFileComplete from "./reviseNewSupportingFileComplete";
import ReviseNewSupportingFilePending from "./reviseNewSupportingFilePending";
import SupportingFileSubmitComplete from "./supportingFileSubmitComplete";
import styles from "../style/index.module.scss";

const supportingRef = createRef();
const approvePageRef = createRef();
const supportingReplaceFileRef = createRef();
export default class CreateSupportingFileProcess extends SupportingFileProcess {
  /* sort supporting files follow status in revise page */
  handleSortFile = (result: any) => {
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    const tiggerTimes = result.sequence;
    if (tiggerTimes > 1) {
      return handleSortFileByStatus(
        result.supportingFolder.supportingFiles,
        this._formateDate,
        isRevise
      );
    }
    return processDefaultTableSortFile(result.supportingFolder.supportingFiles, this._formateDate);
  };

  render() {
    const {
      procedureStepStatus,
      procedureStatus,
      receiveDate,
      requestByName,
      rejectReason,
      rejectStatus,
      loading,
      supportingFileNum,
      uploadSupportingFileNum,
      flowCategoryID,
    } = this.state.pageState;

    const { supportingTableData, isMount, jbProcedureSavedIn } = this.state;
    // @ts-ignore
    const isSubmitComplete =
      this.isRevisePage && procedureStepStatus === "Complete" && this.triggerTimes === 1;
    // @ts-ignore
    const isApprovePending = !this.isRevisePage && procedureStepStatus === "Pending";
    // @ts-ignore
    const isApproveComplete = !this.isRevisePage && procedureStepStatus === "Complete";
    // @ts-ignore
    const isRevisePending =
      this.isRevisePage && procedureStepStatus === "Pending" && this.tiggerTimes > 1;
    // @ts-ignore
    const isReviseComplete =
      this.isRevisePage && procedureStepStatus === "Complete" && this.tiggerTimes > 1;
    const { taskInfoData, procedureInfoData, ppoList, fileTableData, shareTaskData } = this.state;
    const serverPathValue =
      this.state.serverPathSectionState !== undefined
        ? this.state.serverPathSectionState.serverPathValue
        : "";
    const savedInRadioValue =
      this.state.savedInSectionState !== undefined
        ? this.state.savedInSectionState.savedInRadioValue
        : null;

    const newRejectReason = rejectReason;

    const newSupportingTableData = JSON.parse(JSON.stringify(supportingTableData));

    const isCopyPage = flowCategoryID && flowCategoryID === flowCategoryId.copySupportingFile;

    // @ts-ignore
    const isRejectCompletePage = this.actionID === actions.reject;

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          supportingFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {uploadSupportingFileNum}/{supportingFileNum} file
            </p>
          ) : undefined
        }
        children={
          <>
            {isSubmitComplete && (
              // @ts-ignore
              <SupportingFileSubmitComplete
                params={{
                  // @ts-ignore
                  ProcedureTaskId: this.taskID,
                  // @ts-ignore
                  ProcedureID: this.procedureID,
                  // @ts-ignore
                  ProcedureStepID: this.procedureStepID,
                }}
                pageProps={{
                  flowCategoryID,
                  procedureStatus,
                  receiveDate,
                  requestByName,
                }}
                sectionProps={{
                  taskInfoData,
                  procedureInfoData,
                  ppoList,
                  fileTableData,
                  jbProcedureSavedIn,
                }}
                supportingRef={supportingRef}
                isMount={isMount}
                isCopyPage={isCopyPage}
                shareTaskData={shareTaskData}
                _showLoading={this._showLoading}
                _hideLoading={this._hideLoading}
                initSupportingTableData={[...(this as any).initSupportingTableData]}
                handleReturnSubmitData={this.handleReturnSubmitData}
                setProcedureFileData={this.setProcedureFileData}
                setSupportingFileData={this.setSupportingFileData}
                setTaskInfoData={this.setTaskInfoData}
                setProcedureInfoData={this.setProcedureInfoData}
                setShareTaskData={this.setShareTaskData}
                data={newSupportingTableData}
                serverPathValue={serverPathValue}
                savedInRadioValue={savedInRadioValue}
              />
            )}
            {isApprovePending && (
              // @ts-ignore
              <ApproveNewSupportingFilePending
                params={{
                  // @ts-ignore
                  ProcedureTaskId: this.taskID,
                  // @ts-ignore
                  ProcedureID: this.procedureID,
                  // @ts-ignore
                  ProcedureStepID: this.procedureStepID,
                }}
                pageProps={{
                  flowCategoryID,
                  procedureStatus,
                  receiveDate,
                  requestByName,
                  newRejectReason,
                  rejectStatus,
                  supportingReplaceFileRef,
                  isDisableAll: false,
                }}
                sectionProps={{
                  taskInfoData,
                  procedureInfoData,
                  ppoList,
                  fileTableData,
                  jbProcedureSavedIn,
                }}
                closePage={this.closePage}
                ref={approvePageRef}
                approvePageRef={approvePageRef}
                shareTaskData={shareTaskData}
                supportingRef={supportingRef}
                initSupportingTableData={[...(this as any).initSupportingTableData]}
                data={newSupportingTableData}
                serverPathValue={serverPathValue}
                savedInRadioValue={savedInRadioValue}
                handleReturnSubmitData={this.handleReturnSubmitData}
                isMount={isMount}
                setProcedureFileData={this.setProcedureFileData}
                setProcedureInfoData={this.setProcedureInfoData}
                setShareTaskData={this.setShareTaskData}
                setSupportingFileData={this.setSupportingFileData}
                setTaskInfoData={this.setTaskInfoData}
                _showLoading={this._showLoading}
                _hideLoading={this._hideLoading}
              />
            )}
            {isApproveComplete && (
              // @ts-ignore
              <ApproveNewSupportingFileComplete
                params={{
                  // @ts-ignore
                  ProcedureStepID: this.procedureStepID,
                  // @ts-ignore
                  ProcedureTaskId: this.taskID,
                  // @ts-ignore
                  ProcedureID: this.procedureID,
                }}
                sectionProps={{
                  taskInfoData,
                  fileTableData,
                  procedureInfoData,
                  ppoList,
                  jbProcedureSavedIn,
                }}
                pageProps={{
                  flowCategoryID,
                  procedureStatus,
                  // @ts-ignore
                  actionID: this.actionID,
                  supportingReplaceFileRef,
                  isDisableAll: true,
                  receiveDate,
                  requestByName,
                  newRejectReason,
                  rejectStatus,
                }}
                initSupportingTableData={[...(this as any).initSupportingTableData]}
                data={newSupportingTableData}
                serverPathValue={serverPathValue}
                savedInRadioValue={savedInRadioValue}
                ref={approvePageRef}
                approvePageRef={approvePageRef}
                isMount={isMount}
                isCopyPage={isCopyPage}
                shareTaskData={shareTaskData}
                supportingRef={supportingRef}
                _showLoading={this._showLoading}
                _hideLoading={this._hideLoading}
                setProcedureFileData={this.setProcedureFileData}
                setSupportingFileData={this.setSupportingFileData}
                setTaskInfoData={this.setTaskInfoData}
                setProcedureInfoData={this.setProcedureInfoData}
                setShareTaskData={this.setShareTaskData}
                updateSupportingFileNum={this.updateSupportingFileNum}
                isRejectCompletePage={isRejectCompletePage}
              />
            )}
            {isRevisePending && (
              // @ts-ignore
              <ReviseNewSupportingFilePending
                params={{
                  // @ts-ignore
                  ProcedureTaskId: this.taskID,
                  // @ts-ignore
                  ProcedureID: this.procedureID,
                  // @ts-ignore
                  ProcedureStepID: this.procedureStepID,
                }}
                pageProps={{
                  flowCategoryID,
                  procedureStatus,
                  receiveDate,
                  requestByName,
                  newRejectReason,
                  rejectStatus,
                  // @ts-ignore
                  actionID: this.actionID,
                  supportingReplaceFileRef,
                  isDisableAll: false,
                }}
                sectionProps={{
                  taskInfoData,
                  procedureInfoData,
                  ppoList,
                  fileTableData,
                  jbProcedureSavedIn,
                }}
                initSupportingTableData={[...(this as any).initSupportingTableData]}
                updateSupportingFileNum={this.updateSupportingFileNum}
                isMount={isMount}
                shareTaskData={shareTaskData}
                supportingRef={supportingRef}
                _showLoading={this._showLoading}
                _hideLoading={this._hideLoading}
                setTaskInfoData={this.setTaskInfoData}
                setProcedureInfoData={this.setProcedureInfoData}
                setShareTaskData={this.setShareTaskData}
                setProcedureFileData={this.setProcedureFileData}
                setSupportingFileData={this.setSupportingFileData}
                approvePageRef={approvePageRef}
                handleReturnSubmitData={this.handleReturnSubmitData}
                closePage={this.closePage}
                data={newSupportingTableData}
                serverPathValue={serverPathValue}
                savedInRadioValue={savedInRadioValue}
                ref={approvePageRef}
              />
            )}
            {isReviseComplete && (
              // @ts-ignore
              <ReviseNewSupportingFileComplete
                pageProps={{
                  newRejectReason,
                  rejectStatus,
                  // @ts-ignore
                  actionID: this.actionID,
                  supportingReplaceFileRef,
                  flowCategoryID,
                  procedureStatus,
                  receiveDate,
                  requestByName,
                  isDisableAll: true,
                }}
                sectionProps={{
                  taskInfoData,
                  procedureInfoData,
                  fileTableData,
                  jbProcedureSavedIn,
                  ppoList,
                }}
                params={{
                  // @ts-ignore
                  ProcedureTaskId: this.taskID,
                  // @ts-ignore
                  ProcedureID: this.procedureID,
                  // @ts-ignore
                  ProcedureStepID: this.procedureStepID,
                }}
                shareTaskData={shareTaskData}
                _hideLoading={this._hideLoading}
                isMount={isMount}
                initSupportingTableData={[...(this as any).initSupportingTableData]}
                data={newSupportingTableData}
                setProcedureInfoData={this.setProcedureInfoData}
                setShareTaskData={this.setShareTaskData}
                isCopyPage={isCopyPage}
                setProcedureFileData={this.setProcedureFileData}
                setSupportingFileData={this.setSupportingFileData}
                setTaskInfoData={this.setTaskInfoData}
                supportingRef={supportingRef}
                _showLoading={this._showLoading}
                serverPathValue={serverPathValue}
                savedInRadioValue={savedInRadioValue}
              />
            )}
          </>
        }
      />
    );
  }
}
